export default "__VITE_ASSET__DAc5DfRO__"